
export type InvalidateSession500 = {
  message?: string;
  success?: boolean;
};
